// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1g2CU","heading":"FNie5","subHeading":"_2Suyc","stepsWrapper":"Eaks4","steps":"_3q5po","knowMore":"kxQnr"};